export const BRAND_NAME = "React Stack";
export const BRAND_GLYPH = "⚛";

export const DOCS_URL = "https://github.com/millionco/react-stack";
export const ISSUES_URL = "https://github.com/millionco/react-stack/issues";

export const AGENT_ENVIRONMENT_VARIABLES = [
  "CI",
  "CLAUDECODE",
  "CURSOR_AGENT",
  "CODEX_CI",
  "OPENCODE",
  "AMP_HOME",
  "AMI",
] as const;
